import React from 'react'
import Card from '@/primitives/Card'
import Image from '@/primitives/Image'
import Text from '@/primitives/Text'
import Slot from '@/primitives/Slot'
import Box from '@/primitives/Box'
import './index.scss'
import Collapse from '@/primitives/Collapse'
import useIsRtl from '@/hooks/useIsRtl'

const SectionCard = ({
  section,
  color,
  showLogo,
  children,
  showAsCollapsed
}) => {
  const isRtl = useIsRtl()

  const logoClassName = `section-card__logo ${
    isRtl ? 'section-card__logo--rtl' : ''
  }`

  return (
    <Card
      className={`section-card section-card--${color} ${
        isRtl ? 'section-card--rtl' : ''
      }`}
    >
      <Slot name='body'>
        {showAsCollapsed ? (
          <Collapse defaultOpen={false}>
            <Slot name='trigger'>
              <Box
                className={`section-card__header ${
                  isRtl ? 'section-card__header--rtl' : ''
                }`}
              >
                <Text size={300} fontWeight={600}>
                  {section}
                </Text>
                {showLogo && (
                  <Image
                    src='/iyris.svg'
                    alt='Iyris Logo'
                    className={logoClassName}
                  />
                )}
              </Box>
            </Slot>
            <Slot name='content'>
              <Box className='section-card__content'>{children}</Box>
            </Slot>
          </Collapse>
        ) : (
          <>
            <Box
              className={`section-card__header ${
                isRtl ? 'section-card__header--rtl' : ''
              }`}
            >
              <Text size={500} fontWeight={600}>
                {section}
              </Text>
              {showLogo && (
                <Image
                  src='/iyris.svg'
                  alt='Iyris Logo'
                  className={logoClassName}
                />
              )}
            </Box>
            <Box className='section-card__content'>{children}</Box>
          </>
        )}
      </Slot>
    </Card>
  )
}

export default SectionCard
